import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { ModuleExpirationInDays } from 'types';

export const getDemoExpirations = async (): Promise<
  ModuleExpirationInDays | undefined
> => {
  const { data }: { data: ModuleExpirationInDays } = await axios.get(
    `/api/system-modules/demo-expirations`
  );
  return data as ModuleExpirationInDays;
};

type QueryFnType = typeof getDemoExpirations;

type UseDemoExpirationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useDemoExpirations = ({ config }: UseDemoExpirationsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['demoExpirations'],
    queryFn: () => getDemoExpirations(),
    ...config,
  });
};
